<div class="card-body row">
    <div class="col-lg-6 text-left">
        <!--<app-search-box></app-search-box>-->
    </div>
    <div class="col-lg-6 text-right">
        <button type="button" class="btn-shadow d-inline-flex align-items-center btn btn-success"
            (click)="addComment()">
            <div><mat-icon class="fa fa-plus-circle" style=" margin-right: 10px; height: 100%;"></mat-icon></div> 
            <span>Add new comment</span>
        </button>
    </div>
</div>
<div class="card-body">
    <ng-container *ngFor="let comment of audience.comments">
        <div class="row">
            <div class="col-md-12 main-card card">
                <br>
                <span>{{comment.created | date:'MMM d, y, H:mm:ss'}} - {{comment.user?.name}}</span>
                <span style="width: 100%; text-align: right;">
                    <a><mat-icon class="pe-7s-trash" (click)="deleteComment(comment)"></mat-icon></a>
                </span>
                <br>
                <span style="word-wrap: break-word; white-space: pre-wrap;">{{comment.comment}}</span>
                <br>
            </div>
        </div>
        <div class="vertical-separator"></div>
    </ng-container>
</div>